import type { TIconProps } from '~/components/icon'
import {
  DISPLAY_NAME,
  type SnackbarScopedProps,
  useSnackbarContext,
} from '../../snackbar'
import { SnackbarActionButton } from '../snackbar-action-button'
import { SnackbarDescription } from '../snackbar-description'
import { SnackbarIcon } from '../snackbar-icon'
import { SnackbarTitle } from '../snackbar-title'
import {
  SnackbarBoxTextVariants,
  SnackbarContentVariants,
} from './snackbar-content.styles'

type SnackbarContentProps = {
  title?: string
  description: string
  onClickAction?: () => void
  closable?: boolean
  iconName?: TIconProps['symbol']
}

export const SnackbarContent = (props: SnackbarContentProps) => {
  const {
    description,
    title,
    onClickAction,
    closable,
    iconName,
    __scopeSnackbar,
  } = props as SnackbarScopedProps<SnackbarContentProps>
  const { layout, setPaused } = useSnackbarContext(
    DISPLAY_NAME,
    __scopeSnackbar
  )
  const handlePause = () => {
    setPaused(true)
  }
  const handleRestart = () => {
    setPaused(false)
  }

  return (
    <div
      className={SnackbarContentVariants({})}
      data-testid="snackbar-content"
      onMouseDown={handlePause}
      onMouseUp={handleRestart}
    >
      {iconName !== undefined && <SnackbarIcon symbol={iconName} />}
      <div className={SnackbarBoxTextVariants({})}>
        {title && <SnackbarTitle>{title}</SnackbarTitle>}
        <SnackbarDescription>{description}</SnackbarDescription>
      </div>
      {layout === undefined && (
        <SnackbarActionButton
          closable={closable}
          onClickAction={onClickAction}
        />
      )}
    </div>
  )
}
